<main>
  <!-- Language Selector -->
  <div class="language-selector" style="text-align: right; padding: 10px; font-size: 14px;">
    <span style="margin-right: 10px;">Sprache / Language:</span>
    <button class="btn btn-sm btn-outline-primary" style="margin-right: 5px;" [class.active]="true">DE</button>
    <button class="btn btn-sm btn-outline-primary" (click)="switchToEnglish()">EN</button>
  </div>

  <div class="branding" *ngIf="whitelabel != null">
    <app-svg [source]="'whitelabels/' + whitelabel" height="64" width="auto"></app-svg>
  </div>

  <div *ngIf="chargingStation?.lat && chargingStation?.lon" leaflet id="map" [leafletOptions]="mapOptions"
    (leafletMapReady)="onMapReady($event)">
  </div>

  <div *ngIf="isInitiated && chargingStation && pricing; else notAvailable">
    <div class="card" *ngIf="isAnyChargingPointAvailable; else notReady">
      <!-- <div class="icon"><app-svg source="icons/feather/flag" height="40"></app-svg></div> -->
      <h2 i18n="@@ChargingPointSubcriptionPriceHeader">
        <strong>{{ chargingStation.name }}</strong>
      </h2>

      <span class="price" *ngIf="pricing">
        <strong *ngIf="chargingStation?.model?.profile?.isDc; else priceIsAc">{{ parsePrice(pricing.priceDc) }}</strong>
        <ng-template #priceIsAc>
          <strong>{{ parsePrice(pricing.price) }}</strong>
        </ng-template>
        <small *ngIf="pricing.hasStartingFee">{{ parsePrice(pricing.startingFeeAmount) }} Startgebühr je angefangener Ladevorgang<br /></small>
        <small i18n="@@PriceUnitIncludeTaxText">pro kWh inkl. 19&thinsp;% MwSt.<br />Mindestbetrag 1,00 €</small>
      </span>

      <a class="button link mb-3 d-flex gap-0 items-center" (click)="scrollTo('help')" i18n="@@HowChargingWorksText">
        <span>&nbsp;Erst Ladekabel verbinden, dann Zahlungsdaten angeben</span>
        <app-svg source="icons/feather/help-circle" style="line-height: 0" height="20"></app-svg>
      </a>

      <form [formGroup]="this.subscriptionFormService.form"
        (ngSubmit)="onSubmit(this.subscriptionFormService.form.value)"
        *ngIf="formCreated && this.subscriptionFormService && publicTransactionRequest == null">

        <!--
        Charging point picker.

        If this charging station has only one charging point, the form will be hidden.
        The singular charging point is pre-selected in typescript.

        If this charging station has multiple charging points, the user will select one by the charging point id.
        This point.id means the actual DATABASE INDEX, NOT THE CONNECTOR ID.
        The user will, however, see the connector id as the charging point label.
        -->
        <div>
          <span class="form-label" *ngIf="chargingStation.chargingPoints.length > 1">Bitte wählen Sie einen Ladepunkt
            aus*</span>
          <div class="form-group" id="charging-point-picker" *ngIf="chargingStation.chargingPoints.length > 1">
            <div *ngFor="let point of chargingStation.chargingPoints; index as i">
              <ng-container *ngTemplateOutlet="chargepointButton, context:{$implicit: point}"></ng-container>
            </div>
            <div class="error" *ngIf="this.subscriptionFormService.hasError('chargingPointId', 'required')">
              <em
                *ngIf="this.subscriptionFormService.validateControl('chargingPointId') && this.subscriptionFormService.hasError('name', 'required')">
                Ladepunkt wird benötigt
              </em>
            </div>
          </div>

          <ng-template #chargepointButton let-point>
            <input type="radio" name="charging-point" [id]="'charging-point-' + point.id"
              formControlName="chargingPointId" [value]="point.id"
              [ngClass]="isChargingPointAvailable(point)?'':'disabled'">
            <label [for]="'charging-point-' + point.id" [ngClass]="isChargingPointAvailable(point)?'':'disabled'">
              <span style="display: flex; align-items: center; gap: 4px;">
                <app-svg source="icons/feather/charging-station" style="transform: scaleX(-1)" height="24"
                  style="line-height: 0;"></app-svg>
                {{ point.connectorId }}
              </span>
            </label>
          </ng-template>

          <hr>

          <div class="form-group mb-2">
            <label for="email" class="form-label" i18n="@@E-MailLabel">E-Mail*</label>
            <input type="text" class="form-control" formControlName="email" id="subscription-email"
              i18n-placeholder="@@EmailPlaceholder" placeholder="E-Mail*" ngbAutoFocus />

            <div class="error" *ngIf="this.subscriptionFormService.hasError('email', 'required')">
              <em
                *ngIf="this.subscriptionFormService.validateControl('email') && this.subscriptionFormService.hasError('email', 'required')">E-Mail
                wird benötigt</em>
              <em
                *ngIf="this.subscriptionFormService.validateControl('email') && this.subscriptionFormService.hasError('email', 'pattern')">Falsche
                Eingabe</em>
            </div>
            <div *ngIf="!anonymous" class="mt-2">
              <label class="form-label">Rechnungsadresse*</label>
              <div class="form-group">
                <div class="address-data">
                  <!-- <input type="text" class="form-control" formControlName="company" id="subscription-company" placeholder="Firma" /> -->
                  <input type="text" class="form-control" formControlName="name" id="subscription-name"
                    placeholder="Name*" />
                  <input type="text" class="form-control" formControlName="street" id="subscription-street"
                    placeholder="Straße*" />
                  <input type="text" class="form-control" formControlName="housenumber" id="subscription-housenumber"
                    placeholder="Hausnummer*" />
                  <input type="text" class="form-control" formControlName="postcode" id="subscription-postcode"
                    placeholder="PLZ*" />
                  <input type="text" class="form-control" formControlName="city" id="subscription-city"
                    placeholder="Stadt*" />
                </div>

                <div class="error" *ngIf="
                                  this.subscriptionFormService.hasError('street', 'required') ||
                                  this.subscriptionFormService.hasError('housenumber', 'required') ||
                                  this.subscriptionFormService.hasError('postcode', 'required') ||
                                  this.subscriptionFormService.hasError('city', 'required')
                                  ">
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('name') && this.subscriptionFormService.hasError('name', 'required')">Name
                    wird benötigt</em>
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('street') && this.subscriptionFormService.hasError('street', 'required')">Straße
                    wird benötigt</em>
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('housenumber') && this.subscriptionFormService.hasError('housenumber', 'required')">Hausnummer
                    wird benötigt</em>
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('postcode') && this.subscriptionFormService.hasError('postcode', 'required')">PLZ
                    wird benötigt</em>
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('city') && this.subscriptionFormService.hasError('city', 'required')">Stadt
                    wird benötigt</em>
                </div>
              </div>
            </div>
          </div>

          <!--CheckBox-->
          <div>
            <!--CheckBoxAnonym-->
            <div class="form-check mb-2">
              <input class="form-check-input" type="checkbox" id="anonymous" formControlName="anonymous" />
              <label class="form-check-label" for="anonymous" i18n="@@anonymousDescription">
                Ich möchte anonym bleiben und verzichte darauf, meine persönlichen Daten (Name und Adresse) für die
                Rechnung anzugeben.
              </label>
            </div>
          </div>

          <ng-container *ngIf="hasStoredAccessToken && loginUrl">
            <hr>
            <label class="form-label" i18n="@@AlreadyHaveAccountLabel">Sie haben bereits ein Konto bei uns?</label>
            <div class="text-center mb-3">
              <a class="btn btn-default w-100" [href]="loginUrl" i18n="@@LoginForRemoteStartButton">Zum Login</a>
            </div>
          </ng-container>

          <hr>

          <div>
            <!--CheckBoxAgb-->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="agbConfirm" formControlName="agbConfirm" />
              <label class="form-check-label" for="agbConfirm" i18n="@@agbConfirmDescription">
                Ich habe die
                <a href="https://uploads-ssl.webflow.com/63d9fc1e4a5c00a5ee5b1f3f/63e24d8ae16849e8e26e42a5_cubos_agb.pdf"
                  target="_blank" class="link-yellow" style="cursor: pointer;">AGB</a>
                der CUBOS Service GmbH gelesen und stimme diesen zu.
              </label>
            </div>
            <!--CheckBoxDsb-->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dsbConfirm" formControlName="dsbConfirm" />
              <label class="form-check-label" for="dsbConfirm" i18n="@@dsbConfirmDescription">
                Ich habe die
                <a data-bs-toggle="modal" data-bs-target="dsModal" class="link-yellow" style="cursor:pointer;"
                  (click)="openDSDialog()">Datenschutzbestimmungen</a>
                der CUBOS Service GmbH gelesen und stimme diesen zu.
              </label>
            </div>
            <!--CheckBoxBookingPolicy-->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="bookingConfirm" formControlName="bookingConfirm" />
              <label class="form-check-label" for="bookingConfirm" i18n="@@bookingConfirmDescription">
                Hiermit bestätige ich, dass ein Betrag von 60 € auf meinem gewählten Zahlungsmittel reserviert wird.
                Nach Abschluss des
                Ladevorgangs wird der tatsächliche Rechnungsbetrag eingezogen und der überschüssige Betrag
                zurückerstattet.
              </label>
            </div>
          </div>

          <div class="pt-1 mt-4 text-center" *ngIf="formCreated && publicTransactionRequest == null">
            <button style="grid-column: span 12" type="submit" id="confirm_subcription" class="button hero"
              [disabled]="!this.subscriptionFormService.form.valid">
              <span *ngIf="!isCreatingStripeForm">Weiter zur Zahlung</span>
              &nbsp;<app-svg source="icons/feather/loader" class="loading" height="24"
                *ngIf="isCreatingStripeForm && publicTransactionRequest == null"></app-svg>
            </button>
          </div>
        </div>
      </form>

      <form method="post" id="payment-form"
        [style]="publicTransactionRequest == null ? 'opacity: 0; max-height: 0px; overflow: hidden;' : ''">
        <ng-container *ngTemplateOutlet="precisionChargeTemplate"></ng-container>
        <hr>
        <div id="payment-element">
          <h2>Bitte wählen Sie eine Zahlungsmethode aus.</h2>
          <div id="card-element"></div>
          <div id="error-message"></div>
        </div>

        <div id="block-info" class="mt-4">
          <app-svg source="icons/feather/info" height="20"></app-svg>
          <span>Es wird ein Betrag in Höhe von {{this.chargingAmountPreview | number:'1.2-2':'de-DE'}} € auf Ihrem Konto
            vorgemerkt,
            bis der endgültige Rechnungsbetrag am Ende des Ladevorgangs von Ihrem Konto abgebucht wird.</span>
        </div>

        <div class="pb-3 mt-4 text-center">
          <button *ngIf="formCreated && isCreatingStripeForm && publicTransactionRequest != null"
            style="grid-column: span 12" type="submit" class="button hero">
            <span *ngIf="!isPaying">Bezahlen und laden</span>
            &nbsp;<app-svg source="icons/feather/loader" class="loading" height="24" *ngIf="isPaying"></app-svg>
          </button>

        </div>
        <button class="button link d-flex gap-0 items-center" type="button" (click)="pageBack()">
          <app-svg source="icons/feather/arrow-left-circle" style="line-height: 0;"
            height="20"></app-svg><span>&nbsp;Zurück</span>
        </button>
      </form>
    </div>

    <div class="card" id="help">
      <h3 (click)="toggleDrawer()" i18n="@@SimpleConvenientHeader"
        style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;">
        Detaillierte Anleitung
        <app-svg [source]="'icons/feather/chevron-down'" [ngClass]="{'rotate-icon': drawerOpen}" height="24"></app-svg>
      </h3>
      <div [@drawerState]="drawerOpen ? 'open' : 'closed'">
        <ol>
          <li>Ladekabel mit dem Fahrzeug verbinden</li>
          <li>E-Mail-Adresse angeben und auf „Weiter zu Zahlung“ klicken.</li>
          <li>Zahlungsmittel auswählen und ggf. Lademengenbegrenzung festlegen.</li>
          <li>Es werden 60 Euro auf dem Zahlungsmittel vorgemerkt um den Ladevorgang zu autorisieren. Eventuell wird
            eine
            Freigabe Ihres Zahlungsmittelinstituts benötigt.</li>
          <li>Bei erfolgreicher Autorisierung startet der Ladevorgang automatisch.</li>
          <li>Sie können den Ladevorgang jederzeit über Ihr Fahrzeug beenden. Zusätzlich erhalten Sie zu Beginn des
            Ladevorgangs
            eine E-Mail mit einem Link, um den Ladevorgang auch über unsere Webseite zu beenden. Falls eine
            Lademengenbegrenzung
            aktiviert wurde, löst diese automatisch bei der gewählten Grenze aus.</li>
          <li>Nach Beenden des Ladevorgangs wird der tatsächliche Rechnungsbetrag einbehalten und der überschüssige
            Betrag
            zurückerstattet. Außerdem wird die Rechnung automatisiert an die angegebene E-Mail-Adresse versendet.</li>
        </ol>
      </div>
    </div>

    <ng-container *ngIf="chargingStation?.chargingPoints?.length">
      <div class="form-group mb-4 mx-auto" style="max-width: 740px; padding: 0 32px;">
        <strong i18n="@@EvseIdListLabel">EVSE-IDs</strong>
        <div *ngFor="let point of chargingStation.chargingPoints">
          <span i18n="@@ChargePointLabel">Ladepunkt</span> {{ point.connectorId }}: {{ point.evseId }}
        </div>
      </div>
    </ng-container>

    <p *ngIf="chargingStation.hotlinePhoneNumber" style="text-align: center; margin-bottom: 1.5rem;">
      <strong>Hotline</strong><br />
      <strong style="font-size: 1.5rem; font-weight: 900">{{ chargingStation.hotlinePhoneNumber }}</strong>
    </p>

    <p *ngIf="chargingStation.customer" i18n="@@ChargingPointElectricityProviderInfoText">
      Ladepunkt und Strom werden bereitgestellt von <a *ngIf="parkOwner && parkOwner.email else company"
        [href]="'https://www.'+parkOwner.email.split('@')[1]" target="_blank">{{ chargingStation.customer.name }}</a>.
      <ng-template #company>{{ chargingStation.customer.name }}</ng-template>
    </p>
    <p>
      <img src="assets/favicon-32x32.png" alt="CUBOS" />
      <a href="https://www.cubos.com" target="_blank"><strong>Powered&nbsp;by CUBOS</strong></a>
      <span>&copy; Copyright&nbsp;{{ getFullYear() }} CUBOS&nbsp;Service&nbsp;GmbH. Alle Rechte vorbehalten.</span>
    </p>
  </div>
</main>

<ng-template #precisionChargeTemplate>
  <div class="precisionChargeCheckbox mb-2">
    <input class="form-check-input" type="checkbox" id="precisionChargeCheckbox" (change)="togglePrecisionCharge()" />
    <label class="form-check-label" for="precisionChargeCheckbox" i18n="@@precisionChargeCheckboxLabel">Ich möchte die
      Lademenge begrenzen</label>
  </div>

  <div class="precisionCharging mb-2" *ngIf="precisionCharge">
    <div id="block-info">
      <app-svg source="icons/feather/info" height="20"></app-svg>
      <span><b>Bitte beachten Sie, dass die Begrenzung nur eine Genauigkeit von 0,5 kWh hat. Die ausgegebene kWh-Menge
          ist eichrechtskonform. Die Rechnung wird auf Basis der tatsächlich ausgegebenen kWh-Menge erstellt.</b></span>
    </div>

    <div class="toggle-unit rounded-pill" (click)="toggleUnit()">
      <h5 [ngClass]="{'active': chargingUnit == 'euro'}">Euro</h5>
      <h5 [ngClass]="{'active': chargingUnit == 'kwh'}">kWh</h5>
    </div>
    <div class="slider" [ngClass]="{'slide-euro': chargingUnit == 'euro', 'slide-kwh': chargingUnit == 'kwh'}"></div>

    <div class="select-amount" *ngIf="chargingUnit == 'euro'">
      <div>
        <button [ngClass]="{'active': chargingUnit == 'euro' && chargingAmount == 500}" type="button" class="btn"
          value="500" (click)="selectAmount(500)">5&nbsp;€</button>
        <button [ngClass]="{'active': chargingUnit == 'euro' && chargingAmount == 1000}" type="button" class="btn"
          value="1000" (click)="selectAmount(1000)">10&nbsp;€</button>
      </div>
      <div>
        <button [ngClass]="{'active': chargingUnit == 'euro' && chargingAmount == 2000}" type="button" class="btn"
          value="2000" (click)="selectAmount(2000)">20&nbsp;€</button>
        <button [ngClass]="{'active': chargingUnit == 'euro' && chargingAmount == 3000}" type="button" class="btn"
          value="3000" (click)="selectAmount(3000)">30&nbsp;€</button>
      </div>
    </div>

    <div class="select-amount" *ngIf="chargingUnit == 'kwh'">
      <div>
        <button [ngClass]="{'active': chargingUnit == 'kwh' && chargingAmount == 500}" type="button" class="btn"
          value="500" (click)="selectAmount(500)">5&nbsp;kWh</button>
        <button [ngClass]="{'active': chargingUnit == 'kwh' && chargingAmount == 1000}" type="button" class="btn"
          value="1000" (click)="selectAmount(1000)">10&nbsp;kWh</button>
      </div>
      <div>
        <button [ngClass]="{'active': chargingUnit == 'kwh' && chargingAmount == 2000}" type="button" class="btn"
          value="2000" (click)="selectAmount(2000)">20&nbsp;kWh</button>
        <button [ngClass]="{'active': chargingUnit == 'kwh' && chargingAmount == 3000}" type="button" class="btn"
          value="3000" (click)="selectAmount(3000)">30&nbsp;kWh</button>
      </div>
    </div>

    <div class="error align-self-start" *ngIf="!chargingAmount" style="margin-top: -0.7rem">
      <em>Maximaler Ladebetrag wird benötigt</em>
    </div>
  </div>
</ng-template>

<ng-template #notAvailable>
  <div class="wrapper">
    <div class="card" *ngIf="isInitiated; else notInitiated">
      <div class="icon"><app-svg source="icons/feather/zap-off" height="40"></app-svg></div>
      <h2 *ngIf="chargingStation" i18n="@@NotAvailableHeader"><strong>{{ chargingStation.name }}</strong> ist nicht
        verfügbar</h2>
      <h2 *ngIf="!chargingStation" i18n="@@ChargePointNotAvailableHeader">Der Ladepunkt ist nicht verfügbar</h2>
      <ng-container *ngIf="hasStoredAccessToken && loginUrl">
        <hr>
        <p class="form-label text-center" i18n="@@LoginUnavailableFallbackLabel">Bitte einloggen und über Remote-Start
          versuchen.
        </p>
        <div class="text-center mt-2 mb-3">
          <a class="btn btn-default w-100" [href]="loginUrl" i18n="@@LoginForRemoteStartButton">Zum Login</a>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #notInitiated>
  <div class="card">
    <div class="icon"><app-svg source="icons/feather/loader" class="loading" height="40"></app-svg></div>
    <h2 *ngIf="chargingStation"><strong>{{ chargingStation.name }}</strong> wird angefragt</h2>
    <h2 *ngIf="!chargingStation">Der Ladepunkt wird angefragt</h2>
  </div>
</ng-template>

<ng-template #notReady>
  <div class="card">
    <div class="icon"><app-svg source="icons/feather/lock" height="40"></app-svg></div>
    <h2 i18n="@@ChargingPointNotAvailableHeader"><strong>{{ chargingStation.name }}</strong> ist nicht verfügbar</h2>
    <ng-container *ngIf="hasStoredAccessToken && loginUrl">
      <hr>
      <p class="form-label text-center" i18n="@@LoginUnavailableFallbackLabel">Bitte einloggen und über Remote-Start
        versuchen.</p>
      <div class="text-center mt-2 mb-3">
        <a class="btn btn-default w-100" [href]="loginUrl" i18n="@@LoginForRemoteStartButton">Zum Login</a>
      </div>
    </ng-container>
  </div>
</ng-template>